import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Scrollbars } from "react-custom-scrollbars";
import BasicPagination from "../../../Pagination/Pagination";
import Loader from "react-loader-spinner";
import {
  Col,
  Container,
  Row,
  Table,
  Button,
  Image,
  Modal,
} from "react-bootstrap";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { Paper, InputBase, IconButton } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getAllCateogryForIcons } from "../../../../store/actions/SuperAdminActions/adminCategoryAndIconsAction";
import { superadmin_get_all_faq_by_catid } from "../../../../store/actions/SuperAdminActions/superAdminFAQAction";
import isEmpty from "../../../../store/validation/is-Empty";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import SuperAdminAddFAQ from "./SuperAdminAddFAQ";
import SuperAdminHelpFAQdisplayModal from "./SuperAdminHelpFAQdisplayModal";
import CSVDownloader from "../../../reusableComponents/csvDownload/csvDownload";

const checkboxes = [
  { id: 0, text: "User" },
  { id: 1, text: "Vendor" },
  { id: 2, text: "Super Admin" },
  { id: 3, text: "Affiliate User" },
];

function SuperadminFAQManagement(props) {
  const dispatch = useDispatch();

  const [active, setActive] = useState(0);
  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const [showFilter, handleShowFilter] = useState(false);
  const [filterData, setFilterData] = useState([]);
  const [secondFilter, setSecondFilter] = useState([]);
  const openFilterBox = () => {
    setFilterData([]);
    handleShowFilter(true);
  };

  const onChange = (id) => {
    const selectedCheckboxes = filterData;
    const findIdx = selectedCheckboxes.indexOf(id);
    if (findIdx > -1) {
      selectedCheckboxes.splice(findIdx, 1);
    } else {
      selectedCheckboxes.push(id);
    }
    setFilterData(selectedCheckboxes);
  };

  const handleFilterSubmit = (e) => {
    console.log("Filter ===>", filterData);
    const finalData = filterData;
    setFilterData([]);
    setSecondFilter(finalData);
    // handleShowFilter(false);
    //
  };

  const handleBatchChange = (pageNo) => {
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  const [search, setSearch] = useState("");
  const [allCategory, setCategory] = useState([]);
  const [subCategory, setSubCategory] = useState([]);
  /************************************
   * @DESC GET ALL CATEGORY
   ************************************/
  useEffect(() => {
    dispatch(getAllCateogryForIcons(onSuccessGetFavChain));
  }, []);

  const onSuccessGetFavChain = (data) => {
    var cateogryIcons = [];
    for (var i = 0; i < data.length; i++) {
      cateogryIcons.push({ name: data[i].title, id: data[i]._id });
    }
    if (cateogryIcons.length > 0) {
      onClickGetSubCategory(cateogryIcons[0].id);
    }
    setCategory(cateogryIcons);
  };

  const onChangeSearch = (e) => {
    setSearch(e.target.value);
    setSubCategory([]);
  };
  const filteredCategories = allCategory.filter((catName) => {
    return catName.name.toLowerCase().includes(search);
  });

  let filteredSubCategories = subCategory && subCategory;
  let dataFilter = [];
  if (secondFilter.length !== 0) {
    dataFilter = filteredSubCategories.filter(
      (item) => JSON.stringify(item.role) === JSON.stringify(secondFilter)
    );
  } else {
    dataFilter = filteredSubCategories;
  }

  const handleShowIconList = (e, categoryId) => {
    setActive(e);
    setStart(0);
    setEnd(10);
    setPage(1);
    onClickGetSubCategory(categoryId);
    // setSelectedCategory(categoryId);
  };

  const onClickGetSubCategory = (categoryId) => {
    const token = props.auth.user.accessToken;
    props.superadmin_get_all_faq_by_catid(
      categoryId,
      token
      // onSuccessGetSubCategory
    );
  };

  useEffect(() => {
    setSubCategory(props.gethelpFaq);
  }, [props.gethelpFaq]);

  const downloadData = {
    headers: [
      { label: "Sr.no", key: "sno" },
      { label: "Questions", key: "qands" },
    ],
    data: dataFilter
      ? dataFilter?.map((ele) => {
          return {
            sno: ele?.serialNo,
            qands: `${ele?.question} \n ${ele?.answer}  `,
          };
        })
      : [],
  };

  return (
    <React.Fragment>
      {console.log(secondFilter)}
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation />
            <Container fluid>
              <div className="col-12">
                <div className="d-flex justify-content-between align-items-center pt-4 pb-3 col">
                  <div className="f24_700_HelveticaNeue ">
                    Administrations & FAQ
                  </div>
                  <SuperAdminAddFAQ type="add" />
                </div>
              </div>
              <Row>
                <Col md={3}>
                  <div className="filter-button-search">
                    <Paper component="form" className="enSearch2 d-flex">
                      <IconButton type="submit" aria-label="search">
                        <SearchIcon />
                      </IconButton>
                      <InputBase
                        placeholder="Search by categories"
                        name="search"
                        inputProps={{
                          "aria-label": "Search by Name or Phone Number",
                        }}
                        value={search}
                        onChange={(e) => onChangeSearch(e)}
                      />
                    </Paper>
                  </div>
                </Col>
                <Col md={5}></Col>
                <Col md={2} align="right">
                  <div className="d-flex align-items-center">
                    <div className="text-blue f15-500 ml-5 mr-3">Filters</div>
                    <IconButton className="enDownIcon" onClick={openFilterBox}>
                      <Image
                        src={require("../../../../assets/images/UserManagement/chevron-down.svg")}
                        alt="View"
                        title="View"
                      />
                    </IconButton>
                  </div>
                </Col>
                <Col md={2}>
                    <div className="f10-400" align="center">
                      <CSVDownloader
                        filename={"Faq-Report"}
                        headers={downloadData.headers}
                        data={downloadData.data}
                      />
                    </div>
                </Col>
              </Row>
              {showFilter && (
                <div
                  className="p-3 mt-3 mb-3"
                  style={{ backgroundColor: "#ffffff" }}
                >
                  <Row className="p-3">
                    {checkboxes.map((checkbox, index) => (
                      <Col md={2} className="p-1 f11-500" key={index}>
                        <label key={checkbox.id}>
                          <input
                            type="checkbox"
                            onChange={() => onChange(checkbox.id)}
                            selected={filterData.includes(checkbox.id)}
                          />
                          {"  "}
                          {checkbox.text}
                        </label>
                      </Col>
                    ))}
                  </Row>
                  <div className="mt-2 mb-2">
                    <div className="d-flex align-items-center">
                      <button
                        type="button"
                        className="btn-md mr-4 px-5 btn btn-outline-secondary"
                        onClick={(e) => handleShowFilter(!showFilter)}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="btn-md px-5 btn btn-danger"
                        onClick={handleFilterSubmit}
                      >
                        Search
                      </button>
                    </div>
                  </div>
                </div>
              )}
              <Row className="mt-2">
                <Col md={3} style={{ backgroundColor: "#F5F5F5" }}>
                  <div className="p-3" style={{ backgroundColor: "#ffffff" }}>
                    Categories
                  </div>
                  <Scrollbars style={{ width: "100%", height: 500 }}>
                    <div className="enCategoryList">
                      {filteredCategories.map((item, index) => (
                        <button
                          key={index}
                          type="button"
                          className={`f14-400 ${
                            active === index ? "active" : ""
                          }`}
                          onClick={() => handleShowIconList(index, item.id)}
                        >
                          {item.name}
                        </button>
                      ))}
                      {filteredCategories.length === 0 ? (
                        <> No record found </>
                      ) : (
                        <> </>
                      )}
                    </div>
                  </Scrollbars>
                </Col>
                <Col md={9}>
                  <div className="user-table-reusable-superadmin table-responsive">
                    <Table>
                      <thead>
                        <tr className="super_admin_all_users_table_head">
                          <th style={{ width: "15%" }} className="f12-700">
                            Sr. No.
                          </th>
                          <th style={{ width: "85%" }} className="f12-700">
                            Questions
                          </th>
                        </tr>
                      </thead>
                      {dataFilter &&
                        dataFilter.slice(start, end).map((user, index) => {
                          return (
                            <React.Fragment key={index}>
                              <SuperAdminHelpFAQdisplayModal
                                serialNo={++index}
                                question={user.question}
                                answer={user.answer}
                                handleShowEdit={user}
                                handleShowDelete={user}
                              />
                            </React.Fragment>
                          );
                        })}
                    </Table>
                  </div>
                  {dataFilter.length !== 0 ? (
                    <BasicPagination
                      totalRecords={dataFilter.length}
                      limit={10}
                      batch={page}
                      onBatchChange={(e) => handleBatchChange(e)}
                    />
                  ) : (
                    <></>
                  )}
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

SuperadminFAQManagement.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  getAllCateogryForIcons: PropTypes.func.isRequired,
  superadmin_get_all_faq_by_catid: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  gethelpFaq: state.superAdminHelpFaq.get_sub_category_help_faq,
});

export default connect(mapStateToProps, {
  superadmin_get_all_faq_by_catid,
  getAllCateogryForIcons,
})(withRouter(SuperadminFAQManagement));
